import publicDriverFactory from './Input.driver';
import { dataHooks } from './constants';

const inputPrivateDriverFactory = ({ element, eventTrigger }) => {
  const driver = {
    ...publicDriverFactory({ element, eventTrigger }),
    statusIndicatorExists: () => {
      const statusIndicator = element.querySelector(
        `[data-hook="${dataHooks.status}"]`,
      );
      return !!statusIndicator;
    },
  };

  return driver;
};

export default inputPrivateDriverFactory;
